import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      props: { title: "Products", icon: "iconProducts", comp: 'Assets' },
      component: () => import("@/views/Home")
    },
    {
      path: "/dashboard",
      name: "dashboard",
      props: { title: "Products", icon: "iconProducts", comp: 'Assets' },
      component: () => import("@/views/DashboardBase")
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/Login")
    },
    {
      name: "register",
      path: "/register",
      component: () => import("@/views/Register")
    },
    {
      name: "settings",
      path: "/settings",
      component: () => import("@/views/Settings")
    },
    {
      name: "upload",
      path: "/upload",
      props: { title: "Upload", icon: "upload", comp: 'Upload' },
      component: () => import("@/views/DashboardBase")
    },
    {
      name: "sync-history",
      path: "/sync-history",
      props: { title: "Sync history", icon: "document", comp: 'SyncHistory' },
      component: () => import("@/views/DashboardBase")
    },
    // Handle child routes with a default, by giving the name to the
    // child.
    // SO: https://github.com/vuejs/vue-router/issues/777
    {
      path: "/@:username",
      component: () => import("@/views/Profile"),
      children: [
        {
          path: "",
          name: "profile",
          component: () => import("@/views/ProfileArticles")
        },
        {
          name: "profile-favorites",
          path: "favorites",
          component: () => import("@/views/ProfileFavorited")
        }
      ]
    },
    {
      name: "article",
      path: "/articles/:slug",
      component: () => import("@/views/Article"),
      props: true
    },
    {
      name: "article-edit",
      path: "/editor/:slug?",
      props: true,
      component: () => import("@/views/ArticleEdit")
    }
  ]
});
